import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const LoaderOutlinedSize96Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={96} height={96} viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M84 48C84 67.8823 67.8823 84 48 84C28.1177 84 12 67.8823 12 48C12 28.1177 28.1177 12 48 12"
            stroke="var(--magritte-ui-icon-color)"
            strokeWidth={8}
            strokeLinecap="round"
        />
    </svg>
);
const LoaderOutlinedSize96 = hoc<'LoaderOutlinedSize96'>(
    forwardRef(LoaderOutlinedSize96Component),
    'LoaderOutlinedSize96'
);
export default LoaderOutlinedSize96;
